<script setup lang="ts">
import type { Component } from 'vue'

import { Button } from '@/shared/ui/Button'
import { Tooltip } from '@/shared/ui/Tooltip'

/**
 * The two-state button of a table row — "Add" / "Remove" with the whole sentence in its
 * tooltip, and the spinner on the row being written rather than on the list around it.
 *
 * Which state it is in and what pressing it writes belong to the feature that renders it:
 * pass the `label`, the `hint` and the `icon` of the state the button is *offering*, and
 * drive `loading` from the row's own mutation, never from the list's.
 */
defineProps<{
  label: string
  hint: string
  icon: Component
  loading?: boolean
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <Tooltip :content="hint" placement="top">
    <Button
      size="small"
      round
      :icon="icon"
      :loading="loading"
      @click="emit('click')"
    >
      {{ label }}
    </Button>
  </Tooltip>
</template>
